import { WhiteSection } from 'components/base/layout-components';
import {
  StyledGraphsRow,
  StyledResourceAllocationOverview
} from './ResourceAllocationOverview.style';
import Header from './Header';
import AllocationOverTime from './AllocationOverTime';
import FteAllocation from './FteAllocation';
import JiraStats from './JiraStats';
import useAvailability from './useAvailability';
import EmptyState from './EmptyState';
import SettingsButton from './settings/SettingsButton';
import useAmplitudeVisit from 'common/hooks/tracking/useAmplitudeVisit';
import { TRACKING } from 'common/constants/constants';
import ResourceAllocationProvider from './state/Provider';
import { ResourceAllocationFiltersContext } from '../state/filters/contexts';
import FiltersProvider from '../state/filters/FiltersProvider';
import useSidebarState from 'components/Sidebar/hooks/useSidebarState';
import ProjectsFiltersBar from '../state/filters/components/ProjectsFiltersBar';

const ResourceAllocationOverview = () => {
  useAmplitudeVisit({ page: TRACKING.PAGES.RESOURCE_ALLOCATION });
  const { isEmptyState } = useAvailability();
  const { allocationOverTimeWidth } = useSidebarState();

  if (isEmptyState) return <EmptyState />;

  return (
    <ResourceAllocationProvider>
      <FiltersProvider
        Context={ResourceAllocationFiltersContext}
        withInitialFilters={false}
      >
        <ProjectsFiltersBar Context={ResourceAllocationFiltersContext} />

        <StyledResourceAllocationOverview
          allocationOverTimeWidth={allocationOverTimeWidth}
        >
          <WhiteSection>
            <Header
              Context={ResourceAllocationFiltersContext}
              SettingsButton={SettingsButton}
            />
          </WhiteSection>

          <StyledGraphsRow>
            <WhiteSection className='fte-allocation'>
              <FteAllocation />
            </WhiteSection>
            <WhiteSection className='allocation-over-time'>
              <AllocationOverTime />
            </WhiteSection>
          </StyledGraphsRow>

          <WhiteSection>
            <JiraStats />
          </WhiteSection>
        </StyledResourceAllocationOverview>
      </FiltersProvider>
    </ResourceAllocationProvider>
  );
};

export default ResourceAllocationOverview;
